export default {
  message: (state) => (state.message.text ? state.message : null),
  securityMessage: (state) => state.securityMessage,
  postLoginPath: (state) => state.postLoginPath,
}
